import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { header } from './http/http.service';
import { Location } from '../stores/types';

// Google Time Zone API is proxied via FESH/nginx at `/maps/api` (dev: vite.config.ts server.proxy).
const TIMEZONE_PROXY_PATH = 'maps/api/timezone/json';

export const timeZoneApi = createApi({
  reducerPath: TIMEZONE_PROXY_PATH,
  baseQuery: fetchBaseQuery({
    headers: header,
    baseUrl: `/${TIMEZONE_PROXY_PATH}`,
  }),
  endpoints: (builder) => ({
    fetchtTimezone: builder.query<any, any>({
      query: (location: Location) => {
        return {
          url: '',
          method: 'GET',
          params: location,
        };
      },
    }),
  }),
});

export const { useLazyFetchtTimezoneQuery } = timeZoneApi;
